import { ReactNode, FC } from 'react';
import './Card.scss';

const Card: FC<{
  children?: ReactNode;
  backgroundColor?: string;
  padding?: string;
  style?: any;
}> = ({ backgroundColor, children, padding, style }) => {
  return (
    <div className='card' style={{ backgroundColor, padding, ...style }}>
      {children}
    </div>
  );
};

export default Card;
